import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import SearchSelect from '@/components/Select/SearchSelect/index';
import type { GetOptionDisabled } from '@/types/Controls/TabSelect.types';
import { ArrowDropDown } from '@mui/icons-material';
import { OutlinedInput, outlinedInputClasses, popoverClasses } from '@mui/material';
import type { ReactNode, RefObject } from 'react';

interface IProps<ControlOption> {
  value: ControlOption[];
  onChange: (value: ControlOption[]) => void;
  getOptionDisabled?: GetOptionDisabled<ControlOption>;
  options: ControlOption[];
  disabled?: boolean;
  label: string;
  StartAdornment?: ReactNode;
  selectRef?: RefObject<HTMLDivElement> | null;
  wideView?: boolean;
  wideViewFactor?: number;
  withToggle?: boolean;
  grouped?: boolean;
  withAllOption?: boolean;
}

function FilterSelect<ControlOption extends IControlOption<unknown, unknown>>({
  value,
  label,
  StartAdornment,
  onChange,
  getOptionDisabled,
  options,
  disabled,
  selectRef = null,
  wideView = false,
  wideViewFactor = 2,
  withToggle = false,
  grouped = false,
  withAllOption,
}: IProps<ControlOption>) {
  return (
    <SearchSelect
      disabled={disabled}
      value={value}
      onChange={onChange}
      options={options}
      label={label}
      closeOnClickOutside
      dimBackground={false}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={
        selectRef?.current && {
          [`& .${popoverClasses.paper}`]: {
            width: wideView ? selectRef?.current?.offsetWidth * wideViewFactor : selectRef?.current?.offsetWidth,
            minWidth: 250,
          },
        }
      }
      renderInput={props => (
        <OutlinedInput
          readOnly
          startAdornment={StartAdornment}
          endAdornment={<ArrowDropDown />}
          placeholder={`Select ${label}`}
          disabled={disabled}
          value={value?.map(item => item.label)?.join(',')}
          ref={selectRef}
          fullWidth
          sx={{
            height: '45px',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
            [`& .${outlinedInputClasses.input}`]: {
              paddingLeft: '6px',
              paddingRight: 0,
              cursor: 'inherit',
            },
          }}
          {...props}
        />
      )}
      withToggle={withToggle}
      grouped={grouped}
      withAllOption={withAllOption}
      getOptionDisabled={getOptionDisabled}
    />
  );
}

export default FilterSelect;
